import { useEffect, useState } from "react";
import { _BudgetAccountantOperation, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicTable, MASK_DECIMAL, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { EditorBudgetActivity } from "../../../Talentohumano/ParametrosTalentoHumano/BudgetActivity/EditorBudgetActivity";
import { EditorBudgetProduct } from "../../../Talentohumano/ParametrosTalentoHumano/BudgetProduct/EditorBudgetProduct";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { EditorBodegaDocumentos } from "../../../contabilidad/bodegaDocumentos/EditorBodegaDocumentos";

interface Props {
    Project: any;
}
export const CDPInfo = ({ Project }: Props) => {

    const { instance, lista, setLista, bean, setBean, handleChange, addRequiredFields, validateForm } = useDataBean(_BudgetAccountantOperation);
    const paginador = usePaginator();

    const [filter, setFilter] = useState<Record<string, any>>({ IDProject: Project.IDProject, Year: _single.getCurrenYear() });

    const modal = useModal("Agreagr CDPS", MODAL_md);
    const modalC = useModal("Eliminar", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);

    const getLista = () => {
        instance.getCDPBudgetInfoRender(paginador.page, paginador.regiPerPage, filter).then((res) => {
            paginador.setPages(res.NumberOfPages);
            paginador.setRecords(res.NumberOfPages * 15);
            paginador.setRegiPerPage(15);

            res.List.forEach(element => {
                const data = element.DataBeanProperties;
                data.EntityDoc = data.Mnemonic ? `${data.Mnemonic} - ${data.Consecutive}` : "N/P";
            });

            setLista(res.List);
        }).catch(err => { toast.error(err) });
    }

    useEffect(() => {
        addRequiredFields(["GoalScore", "IDBudgetActivity", "IDBudgetProduct"])
        getLista();
    }, [paginador.page, filter.Year, filter.IDProject]);

    const head = [
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Documento', property: 'EntityDoc', visible: true },
        { title: 'Puntaje Meta', property: 'GoalScore', visible: true, mask: MASK_DECIMAL },
        { title: 'Código BPIN', property: 'BPINCode', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre Actividad', property: 'BudgetActivityName', visible: true },
        { title: 'Nombre Producto', property: 'BudgetProductName', visible: true },
        { title: 'Objecto PAA', property: 'AdquisitionItemDescription', visible: true },
    ];

    const create = () => {
        setBean({});
        modal.open();
    }

    const addCDP = () => {
        if (!validateForm()) {
            toast.error("Por favor complete los campos requeridos");
            return;
        }

        instance.setBudgetInfoToCDP(bean.IDBudgetProduct, bean.IDBudgetActivity, bean.GoalScore, Project.IDProject, Project.BpinCode, bean.IDDocument, bean.DocumentDate, _single.getAccountID(), true).then(
            (resp) => {
                getLista();
                modal.close();
            }
        ).catch(err => { toast.error(err) })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.IDDocument, evento: () => { modalSeeDocument.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <YearSelector tittle="Vigencia" value={filter.Year} onChange={(e) => { setFilter({ ...filter, Year: e }) }} />
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} records={paginador} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={addCDP} onSubmitLabel="Agregar">
                    <div className="row">
                        <div className="col-md-12">
                            <label>Puntaje Meta</label>
                            <input type="number" name="GoalScore" className="form-control" value={bean.GoalScore} onChange={handleChange} />
                        </div>
                        <div className="col-md-12">
                            <EditorBodegaDocumentos nemonic="CDP" year={filter.Year} onChange={(e) => { 
                                console.log(e)
                                setBean({ ...bean, IDDocument: e.IDDocument, DocumentDate: e.DocumentDate })
                            }} />
                        </div>
                        <div className="col-md-12">
                            <EditorBudgetActivity idSelector={bean.IDBudgetActivity} onChange={(e) => { setBean({ ...bean, IDBudgetActivity: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <EditorBudgetProduct idSelector={bean.IDBudgetProduct} onChange={(e) => { setBean({ ...bean, IDBudgetProduct: e }) }} />
                        </div>

                    </div>
                </Modal>
            </div>
        </div>
    )
}